import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import StyledIcon from '../../../components/Icon'
import colors from '../../../constants/colors'
import styles from '../../../constants/styles'
import { _ } from '../../../utils/localization'
import { toggleWidget } from '../presentationSlice'
import { Presentation } from './ActionBar'

const S = {
    Widget: styled.div<{isShowWidget: boolean}>`
        background: white;
        width: ${styles.sidebarWidth}px;
        height: 100%;
        position: fixed;
        right: ${({ isShowWidget }) => (isShowWidget ? 0 : -(styles.sidebarWidth))}px;
        transition: 0.75s;
        @media (max-width: 1366px) {
            width: ${styles.smallerSidebarWidth}px;
            right: ${({ isShowWidget }) => (isShowWidget ? 0 : -(styles.smallerSidebarWidth))}px;
        }
    `,
    WidgetOld: styled.div<{isShowWidget: boolean}>`
        position: fixed;
        bottom: 0;
        right: 0;
        width: ${styles.sidebarWidth};
        height: 100%;
        padding: 10px;
        padding-top: 70px;
        background-color: white;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
        transform: translateX(${({ isShowWidget }) => (isShowWidget ? 0 : styles.sidebarWidth)}px);
        transition: 0.75s;
        @media (max-width: 1366px) {
            width: ${styles.smallerSidebarWidth};
            transform: translateX(${({ isShowWidget }) => (isShowWidget ? 0 : styles.smallerSidebarWidth)}px);
        }
    `,
    Header: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid ${colors.gray3};
    `,
    Title: styled.h3`
        margin: 0;
        font-size: 16px;
        padding-right: 16px;
    `,
    IFrameWrapper: styled.div`
        height: 100%;
        width: ${styles.sidebarWidth - 20}px;
        @media (max-width: 1366px) {
            width: ${styles.smallerSidebarWidth - 20}px;
        }
    `
}

const Widget = ({ presentation, isShowWidget }: { presentation: Presentation, isShowWidget: boolean }) => {
    const dispatch = useDispatch()
    const videoRef = useRef<HTMLIFrameElement>()

    useEffect(() => {
        if (!isShowWidget && videoRef.current) {
            videoRef.current.src = presentation.embedded_url // Stop video when hiding Widget
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowWidget])

    if (!presentation || !presentation.embedded_url) {
        return null
    }

    return (
        <S.Widget isShowWidget={isShowWidget}>
            <S.Header>
                <S.Title>{_('presentation.widget.title')}</S.Title>
                <StyledIcon icon="close" style={{ display: 'block' }} onClick={() => dispatch(toggleWidget())} />
            </S.Header>
            <S.IFrameWrapper>
                <iframe
                    src={presentation.embedded_url}
                    title="stream"
                    width="100%"
                    frameBorder="0"
                    style={{ height: 'calc(100% - 120px)' }}
                    ref={videoRef}
                />
            </S.IFrameWrapper>
        </S.Widget>
    )
}

export default Widget
